import { useLocation, useMatchRoute } from "@tanstack/react-router";
import { buildOrgProjectPath } from "@/lib/org-project-context/constants";
import { useOrgProjectRouteContext } from "@/lib/org-project-context/hooks";
import type { SidebarItem, SidebarPath } from "../types";

export function useSidebarUrl() {
  const scope = useOrgProjectRouteContext();

  return (url?: string): SidebarPath | undefined => {
    if (!url) {
      return undefined;
    }
    if (url.startsWith("/orgs/")) {
      // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
      return url as SidebarPath;
    }
    // biome-ignore lint/plugin/no-type-assertion: existing type assertion; prefer type guards for new code
    return buildOrgProjectPath(url, scope) as SidebarPath;
  };
}

export function useSidebarItemActive(item: SidebarItem, resolvedUrl?: string) {
  const location = useLocation();
  const matchRoute = useMatchRoute();
  const currentPath = location.pathname;

  if (!resolvedUrl) {
    return false;
  }

  if (item.activeOnChildRoutes) {
    const basePath = item.activeBasePath ?? resolvedUrl;
    return currentPath.startsWith(basePath);
  }

  return !!matchRoute({ to: resolvedUrl });
}
